/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ who: NonNullable<unknown> }} Ui_PreviewingInputs */

const en_ui_previewing = /** @type {(inputs: Ui_PreviewingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Previewing as ${i?.who}`)
};

/** @type {(inputs: Ui_PreviewingInputs) => LocalizedString} */
const ar_ui_previewing = en_ui_previewing;

/** @type {(inputs: Ui_PreviewingInputs) => LocalizedString} */
const he_ui_previewing = en_ui_previewing;

/** @type {(inputs: Ui_PreviewingInputs) => LocalizedString} */
const ur_ui_previewing = en_ui_previewing;

/** @type {(inputs: Ui_PreviewingInputs) => LocalizedString} */
const es_ui_previewing = en_ui_previewing;

/** @type {(inputs: Ui_PreviewingInputs) => LocalizedString} */
const fr_ui_previewing = en_ui_previewing;

/** @type {(inputs: Ui_PreviewingInputs) => LocalizedString} */
const de_ui_previewing = en_ui_previewing;

/** @type {(inputs: Ui_PreviewingInputs) => LocalizedString} */
const pt_ui_previewing = en_ui_previewing;

/** @type {(inputs: Ui_PreviewingInputs) => LocalizedString} */
const hi_ui_previewing = en_ui_previewing;

/** @type {(inputs: Ui_PreviewingInputs) => LocalizedString} */
const bn_ui_previewing = en_ui_previewing;

/**
* | output |
* | --- |
* | "Previewing as {who}" |
*
* @param {Ui_PreviewingInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_previewing = /** @type {((inputs: Ui_PreviewingInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_PreviewingInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_previewing(inputs)
	if (locale === "he") return he_ui_previewing(inputs)
	if (locale === "ur") return ur_ui_previewing(inputs)
	if (locale === "es") return es_ui_previewing(inputs)
	if (locale === "fr") return fr_ui_previewing(inputs)
	if (locale === "de") return de_ui_previewing(inputs)
	if (locale === "pt") return pt_ui_previewing(inputs)
	if (locale === "hi") return hi_ui_previewing(inputs)
	if (locale === "bn") return bn_ui_previewing(inputs)
	return en_ui_previewing(inputs)
});